import React, { useEffect, useState } from 'react';
import useFolderStructure from '../../../hooks/useFolderStructure';
import FolderStructure from './FolderStructure';
import { getCustomizedStructure } from 'utils/common';
import ComponentTraceLoader from 'components/ComponentTraceLoader';

import Button from 'components/Button';
import { sendAmplitudeEvents } from 'utils/common';

import { EventNames } from 'utils/events';

import { Icon } from 'components/Icons';

const ARTEFACT_COMPLETED_STATUS = 'completed';

export default function WrapperFolderStructure({
  artefactContentStructure,
  currentArtefact,
  downloadArtefactRequest,
}) {
  const {
    activeEventKey,
    setActiveEventKeyAccordian,
    folderStructure,
    handleFolderClick,
    downloadArtefactLink,
  } = useFolderStructure({ artefactContentStructure });

  const [hasMore, setHasMore] = useState(false);

  if (artefactContentStructure?.loading) {
    return <ComponentTraceLoader type="STAGE_LIST" />;
  }

  const [transformedFolderStructure, hasMoreFiles] =
    getCustomizedStructure(folderStructure);

  let className = 'ltw-mt-10px folder-structure-wrapper';

  const showDownload =
    (currentArtefact?.size &&
      currentArtefact?.status === ARTEFACT_COMPLETED_STATUS &&
      currentArtefact?.removed !== true) ||
    currentArtefact?.isArtifactDownloadable;

  if (hasMoreFiles || hasMore) {
    if (showDownload) {
      className += ' has-more-files-wrapper';
    }
  }

  return (
    <div className={className}>
      <FolderStructure
        folderStructure={transformedFolderStructure}
        activeEventKey={activeEventKey}
        setActiveEventKeyAccordian={setActiveEventKeyAccordian}
        handleFolderClick={handleFolderClick}
        downloadArtefactLink={downloadArtefactLink}
        setHasMore={setHasMore}
      />

      {(hasMoreFiles || hasMore) && showDownload && (
        <MoreFilesMessage
          downloadArtefactRequest={downloadArtefactRequest}
          artefactName={currentArtefact?.name}
        />
      )}
    </div>
  );
}

function MoreFilesMessage({ downloadArtefactRequest, artefactName }) {
  useEffect(() => {
    sendAmplitudeEvents(EventNames.HYP_MORE_FILES_MESSAGE_SHOWN);
  }, []);

  return (
    <div className="too-many-files-message">
      <span>Too many files, please download to see all files</span>
      <Button
        ariaLabel="Download Artifact"
        onClick={(e) => {
          e.stopPropagation();
          sendAmplitudeEvents(EventNames.HYP_DOWNLOAD_ARTEFACT_FROM_MODAL);
          downloadArtefactRequest(artefactName);
        }}
        icon={<Icon name={'download-file-icon'} width="15" height="14" />}
        variant={Button.Variant.SECONDARY_TRANSPARENT}
        label={'Download'}
        iconPosition={Button.IconPosition.RIGHT}
      />
    </div>
  );
}
